import React from "react";
const ThumbsUpLargeIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={62}
      height={62}
      viewBox="0 0 62 62"
      xmlns="http://www.w3.org/2000/svg"
      fill="var(--color-theme-600)"
      ref={svgRef}
      {...props}
    >
      <g fillRule="evenodd">
        <path d="M31 12c0 7.828-7.494 9.549-10.999 14C17.843 28.742 17 34 17 34v23c5.95 2.084 9.996 5 22 5 9.58-.094 11.248-.201 15-4 4.001-4 8-19.442 8-28 0-.666-.178-1.429-.358-2.277-.875-4.136-6.202-4.998-10.642-4.998-3.18 0-6.206.488-6.305.488-.945 0-1.392-1.325-.998-2.338C44.877 17.849 45 13.105 45 8c0-8-7-8-7-8s-7 0-7 12z" />
        <path d="M18.256 56.522L24.97 60l11.36 1.5h8.79l7.13-3.638 6.505-18.18v-6.537C56.28 45.367 52.122 52.318 46.274 54c-5.846 1.682-15.094.646-27.743-3.108l-.275 5.63z" />
        <path d="M20 28.666l7.345-6.27 4.283-6.623 1.62-10.71 5.257-3.551 4.822 2.323-.62 5.883c-1.026-3.315-2.558-4.436-4.596-3.362-3.058 1.61.88 14.119-7.32 18.295-8.199 4.176-12.535 15.143-12.535 21.413V32.762L20 28.666z" />
        <path
          d="M37.99 1.502c.47.017 2.606.178 4.075 1.867.85.977 1.435 2.457 1.435 4.631 0 4.882-.071 9.432-1.2 12.331a3.727 3.727 0 00.033 2.727c.206.481.514.878.884 1.158.416.315.913.497 1.478.497.054-.007.11-.014.17-.02l.383-.049c1.312-.163 3.492-.419 5.752-.419 2.295 0 4.862.22 6.795 1.128 1.167.548 2.102 1.366 2.38 2.684.183.851.325 1.44.325 1.963 0 8.201-3.71 23.09-7.567 26.946-3.488 3.531-5.123 3.468-13.941 3.554-8.955-.001-13.338-1.676-17.513-3.369h0l-.55-.223a218.13 218.13 0 00-.833-.337h0l-.558-.222a66.462 66.462 0 00-1.038-.4h0V34.121c.126-.749.89-4.92 2.68-7.193 1.03-1.309 2.444-2.35 3.878-3.41h0l.49-.362h0l.463-.346C29.4 20.261 32.5 17.4 32.5 12c0-3.624.664-6.06 1.605-7.679 1.305-2.245 3.15-2.716 3.743-2.803l.104-.013h0z"
          stroke="#000"
          strokeWidth={3}
        />
        <rect
          stroke="#979797"
          strokeWidth={3}
          x={1.5}
          y={27.5}
          width={17}
          height={33}
          rx={5}
        />
        <rect
          stroke="#000"
          strokeWidth={3}
          x={1.5}
          y={27.5}
          width={17}
          height={33}
          rx={5}
        />
        <path d="M3 51a2 2 0 002 2h10a2 2 0 002-2v6a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
      </g>
    </svg>
  )
);
ThumbsUpLargeIcon.displayName = "ThumbsUpLargeIcon";
export default ThumbsUpLargeIcon;
